export default __webpack_public_path__ + "static/media/redemption_navicon-light.9bdd1e70.svg";